import { message } from "antd";
import { axiosDelete, axiosPatch, axiosPost } from "../axios";

export const updatePersonalSettings = async (payload) => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosPatch({
      path: `user?userId=${uId}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const updateCompanyDetails = async (payload) => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosPatch({
      path: `business?userId=${uId}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const deactivateAcc = async () => {
  try {
    const res = await axiosDelete({
      path: "user",
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const deleteDealCard = async (id) => {
  try {
    const res = await axiosDelete({
      path: `service/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const uploadImage = async (payload) => {
  try {
    const res = await axiosPost({
      path: "user/upload?folder=USERS",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const serviceImage = async (payload) => {
  try {
    const res = await axiosPost({
      path: "user/upload?folder=SERVICES",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const multipleServiceImages = async (payload) => {
  try {
    const res = await axiosPost({
      path: "user/upload-multiple-images?folder=SERVICES",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
